import moment from 'moment'
import * as yup from 'yup'

import constants from 'constants/index'

export const SETTINGS_FIELDS = [
  'category',
  'code',
  'otherCategory',
  'selectedDepartments',
  'selectedUsers',
  'signedDocument',
  'signedDocumentLink',
]

const settingsSchema = (isWrittenContent) =>
  yup.object({
    ...(isWrittenContent && {
      publicDocument: yup.boolean().required(),
      collectAccepted: yup.boolean().required(),
      allowAutomaticEditing: yup.boolean(),
      checkOldVersions: yup.boolean().required(),
      collectApproval: yup.boolean().required(),
    }),
    category: yup.string().required(),
    code: yup.string().required(),
    selectedUsers: yup.array().when('visibilityType', {
      is: constants.documents.USER_ACCESS_PERMISSION_ID,
      then: (schemaOption) =>
        schemaOption
          .min(1, 'Selecione pelo menos 1 usuário')
          .required('Selecione pelo menos 1 usuário'),
      otherwise: (schemaOption) => schemaOption.notRequired(),
    }),
    selectedDepartments: yup.array().when('visibilityType', {
      is: constants.documents.DEPARTMENT_ACCESS_PERMISSION_ID,
      then: (schemaOption) =>
        schemaOption
          .min(1, 'Selecione pelo menos 1 departamento')
          .required('Selecione pelo menos 1 departamento'),
      otherwise: (schemaOption) => schemaOption.notRequired(),
    }),
    signedDocument: yup.mixed().when('collectSignedDocument', {
      is: true,
      then: (schemaOption) =>
        schemaOption
          .fileUpload({ fileGroup: 'document' })
          .test(
            'atLeastOne',
            'Informe o arquivo ou o link do documento',
            function (value) {
              return !!value || !!this.parent.signedDocumentLink
            },
          ),
      otherwise: (schemaOption) => schemaOption.nullable(),
    }),
    signedDocumentLink: yup
      .string()
      .url()
      .when('collectSignedDocument', {
        is: true,
        then: (schemaOption) =>
          schemaOption.test(
            'atLeastOne',
            'Informe o arquivo ou o link do documento',
            function (value) {
              return !!value || !!this.parent.signedDocument
            },
          ),
        otherwise: (schemaOption) => schemaOption.notRequired(),
      }),
    otherCategory: yup
      .string()
      .max(255)
      .when('category', {
        is: 'other',
        then: (schemaOption) => schemaOption.required(),
      }),
    dueDateValue: yup
      .mixed()
      .typeError()
      .nullable()
      .when(['dueDate', 'expirationType'], {
        is: (dueDate, expirationType) =>
          dueDate === true && (expirationType === '0' || expirationType === 0),
        then: (schemaOption) =>
          schemaOption
            .test('is-valid-date', 'Data de vencimento inválida', (value) => {
              if (!value) return false
              if (moment.isMoment(value)) return value.isValid()
              return moment(value).isValid()
            })
            .notInPast({
              inclusiveToday: false,
              message:
                'A data deve ser futura (não pode ser hoje ou no passado).',
            })
            .required(),
      }),

    expirationTime: yup.number().when(['dueDate', 'expirationType'], {
      is: (dueDate, expirationType) =>
        dueDate === true && (expirationType === 1 || expirationType === '1'),
      then: yup
        .number()
        .transform((value, originalValue) =>
          String(originalValue).trim() === '' ? undefined : value,
        )
        .min(1, 'O valor deve ser maior que 0')
        .required(),
    }),
    expirationUnit: yup.string().when(['dueDate', 'expirationType'], {
      is: (dueDate, expirationType) =>
        dueDate === true && (expirationType === 1 || expirationType === '1'),
      then: yup.string().required(),
    }),
  })

export default settingsSchema
